















import OtDocumentLayout from '@/components/documents/document-layout/ot-document-layout.vue';
import { Component, Vue } from 'vue-property-decorator';
import { ROUTE_SETTINGS_ORG_DOCUMENT, ROUTE_SETTINGS_ORG_DOCUMENT_ASSOCIATIONS } from '../settings-routes';

@Component({
  components: {
    OtDocumentLayout,
  },
})
export default class OtOrganisationDocumentLayout extends Vue {
  private get detailsRouteName() {
    return ROUTE_SETTINGS_ORG_DOCUMENT;
  }
  private get associationsRouteName() {
    return ROUTE_SETTINGS_ORG_DOCUMENT_ASSOCIATIONS;
  }
}
